import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { thumb } from "@/lib/img";

const ClientGrid = ({ clients = [], expoName }) => {
  if (!clients.length) {
    return null;
  }
  return (
    <div
      data-testid="client-grid"
      className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5"
    >
      {clients.map((client, i) => (
        <article
          key={`${client.name}-${i}`}
          data-testid={`client-card-${i}`}
          className="client-card aspect-[4/5] group"
        >
          <img
            src={thumb(client.image)}
            alt={`${client.name} stall at ${expoName}`}
            loading="lazy"
            decoding="async"
          />
          <div className="overlay" />
          <div className="meta">
            <div className="font-mono text-[10px] tracking-[0.2em] text-[var(--red)] mb-2">
              {[client.year, client.sqm].filter(Boolean).join(" · ") || client.industry}
            </div>
            <h3 className="font-display text-xl md:text-2xl leading-tight mb-1.5">
              {client.name}
            </h3>
            <div className="text-xs text-[var(--text-soft)] flex items-center gap-1.5">
              <MapPin size={12} /> {client.industry}
            </div>
          </div>
        </article>
      ))}
    </div>
  );
};

export const ExpoCard = ({ expo }) => (
  <Link
    to={`/expo/${expo.slug}`}
    data-testid={`expo-card-${expo.slug}`}
    className="shg-card group flex flex-col h-full"
  >
    <div className="aspect-[16/10] overflow-hidden relative flex-shrink-0">
      <img
        src={thumb(expo.heroImage)}
        alt={`${expo.name} stand builder in ${expo.city}`}
        loading="lazy"
        decoding="async"
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
      <div className="absolute top-4 left-4 flag-chip">
        <MapPin size={11} /> {expo.city}
      </div>
    </div>
    <div className="p-6 flex flex-col flex-1">
      <div className="font-mono text-[10px] tracking-[0.2em] text-[var(--text-muted)] mb-2">
        {expo.month.toUpperCase()} · {expo.clients.length} {expo.clients.length === 1 ? "STAND" : "STANDS"}
      </div>
      <h3 className="font-display text-2xl mb-2 line-clamp-2 group-hover:text-[var(--red)] transition-colors">
        {expo.name}
      </h3>
      <p className="text-sm text-[var(--text-soft)] line-clamp-2 mb-4">
        {expo.description}
      </p>
      <div className="mt-auto flex items-center gap-1.5 text-[var(--red)] text-sm font-medium">
        Explore stands <ArrowUpRight size={15} />
      </div>
    </div>
  </Link>
);

export default ClientGrid;
